<template>
  <div class="info-display">
    <div class="left-column">
      <h1 class="main-title">{{ data.outer_title }}</h1>

      <div class="content-wrapper">
        <div v-for="(block, index) in data.subsequent_texts" :key="index" class="info-card">
          <InfoText v-if="block.type === 'text'" :title="block.title" :content="block.content" />
          <InfoTextEmphasized v-else-if="block.type === 'text-emphasized'" :title="block.title" :content="block.content" />
          <InfoImage v-else-if="block.type === 'image'" :title="block.title" :src="block.src" :alt="block.alt" />
          <InfoAccordion v-else-if="block.type === 'accordion'" :title="block.title" :content="block.content" />
        </div>
      </div>
    </div>

    <div class="right-image">
      <img src="@/assets/images/web/tongxin/bg_content_22.png" alt="Doctor illustration" />
    </div>
  </div>
</template>



<script>
import InfoText from './common/InfoText.vue';
import InfoTextEmphasized from './common/InfoTextEmphasized.vue';
import InfoImage from './common/InfoImage.vue';
import InfoAccordion from './common/InfoAccordion.vue';

export default {
  name: 'InfoDisplay',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    InfoText,
    InfoTextEmphasized,
    InfoImage,
    InfoAccordion,
  }
};
</script>


<style scoped>
.info-display {
  display: flex;
  gap: 32px;
  align-items: stretch;
  background-color: #ffffff;
  font-family: 'Helvetica Neue', sans-serif;

  @media (min-width: 768px) {
    padding: 32px;
  }
}

/* Left column: title + content stacked */
.left-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Title styling */
.main-title {
  font-size: 28px;
  font-weight: bold;
  color: #184a45;
  margin-bottom: 24px;
}

/* Cards container */
.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #ffffff;
}

/* Each card */
.info-card {
  background-color: #f5f7f8;
  border-left: 6px solid #1f9c7b;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Right column: image */
.right-image {
  flex: 0 0 30%;
  max-width: 30%;
  overflow: hidden;
  border-radius: 8px;
  display: flex;
  align-items: stretch;
}

/* Image fills and crops */
.right-image img {
  width: 100%;
  height: 60vh;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

/* Responsive: hide image on small screens */
@media (max-width: 767px) {
  .info-display {
    flex-direction: column;
  }

  .right-image {
    display: none;
  }
}
</style>
